import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { useAuth } from '../contexts/AuthContext';
import SettingsTabs from '../components/settings/SettingsTabs';

const GET_RECENT_CLEANING_JOBS = gql`
  query GetRecentCleaningJobs($input: JobsQueryInput) {
    jobs(input: $input) {
      items {
        id
        category
        cleaningType
        scheduledDate
        status
        property {
          id
          name
        }
        reservation {
          id
          guest_name
          check_in
          check_out
        }
      }
      total
      hasMore
    }
  }
`;

export default function Settings() {
  const { user } = useAuth();
  
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const { loading, error, data, refetch } = useQuery(GET_RECENT_CLEANING_JOBS, {
    variables: {
      input: {
        startDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString(),
        endDate: new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).toISOString()
      }
    }
  });

  if (user?.role?.toLowerCase() !== 'admin') {
    return (
      <div className="max-w-7xl mx-auto py-4 sm:py-6 px-4 sm:px-6 lg:px-8">
        <div className="sm:px-0">
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded-r-md">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  You need administrator privileges to access this page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (loading) return (
    <div className="max-w-7xl mx-auto py-4 sm:py-6 px-4 sm:px-6 lg:px-8">
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="text-gray-500">Loading...</div>
      </div>
    </div>
  );
  
  if (error) return (
    <div className="max-w-7xl mx-auto py-4 sm:py-6 px-4 sm:px-6 lg:px-8">
      <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-r-md">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-red-700">Error: {error.message}</p>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto py-4 sm:py-6 px-4 sm:px-6 lg:px-8">
      <div className="sm:px-0">
        <h1 className="text-2xl font-semibold text-gray-100 lg:text-gray-800 mb-4 sm:mb-6">Settings</h1>
        <SettingsTabs refetchJobs={refetch} userRole={user?.role} />
      </div>
    </div>
  );
}